export const isTranslationKey = (value) =>
  typeof value === 'string'
  && (value.startsWith('diagnosticPage.')
    || value.startsWith('paiementPage.')
    || value.startsWith('common.'));

export const displayMessage = (t, value) => (isTranslationKey(value) ? t(value) : value);
